module.exports = __webpack_public_path__ + "fonts/GothamNarrow-Black.34725f69.otf";